import type { TCliente } from '@/shared/interfaces/cliente.types'
import { HttpService } from '@/shared/lib/http'

export class GetClientePorIdService extends HttpService {
  async execute({ id }: { id: string }) {
    return this.http.get<TCliente>(`api/v2/Cliente/${id}`)
  }
}
